export var getBasePay = function (shiftDuration, payRates) {
    return {
        netWage: ((payRates === null || payRates === void 0 ? void 0 : payRates.rate) || 0) * shiftDuration,
        netShiftDifferential: ((payRates === null || payRates === void 0 ? void 0 : payRates.shiftDifferential) || 0) * shiftDuration
    };
};
